import { FC, useMemo } from "react";
import { useFormContext } from "react-hook-form";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { SKUFormValues } from "@/lib/forms";
import { canEditSKU } from "@/lib/permissions";
import useStore from "@/state";

export const RedirectAttributes: FC = () => {
  const form = useFormContext<SKUFormValues>();
  const { session } = useStore();

  const lacksPermission = useMemo(() => {
    return !canEditSKU(session?.permissions);
  }, [session]);

  return (
    <div>
      <FormField
        control={form.control}
        name="redirect_url"
        disabled={lacksPermission}
        render={({ field }) => (
          <FormItem className="mt-6">
            <FormLabel>Redirect URL</FormLabel>
            <FormControl>
              <Input placeholder="https://www.example.com/" {...field} />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
};
